import React, { useRef, useEffect } from "react";

const PermissionViewModal = ({ open, onClose, permission }) => {
  const modalRef = useRef(null);

  // Close when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (modalRef.current && !modalRef.current.contains(event.target)) {
        onClose();
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [onClose]);

  const getSelectedPermissions = (obj) => {
    let result = {};

    for (const key in obj) {
      const item = obj[key];

      // If module has permissions directly
      if (item.permissions) {
        const selectedPerms = Object.entries(item.permissions)
          .filter(([_, value]) => value === true)
          .reduce((acc, [k]) => ({ ...acc, [k]: true }), {});

        if (Object.keys(selectedPerms).length > 0) {
          result[key] = { permissions: selectedPerms };
        }
      }

      // If module has subModule
      if (item.subModule) {
        const selectedSub = getSelectedPermissions(item.subModule);
        if (Object.keys(selectedSub).length > 0) {
          result[key] = { ...(result[key] || {}), subModule: selectedSub };
        }
      }
    }

    return result;
  };

  const renderPermissions = (obj) => {
    const rows = [];

    const loop = (moduleObj, parent = "") => {
      Object.entries(moduleObj).forEach(([key, item]) => {
        const title = parent ? `${parent} > ${key}` : key;

        // permissions
        if (item.permissions) {
          const perms = Object.keys(item.permissions);
          if (perms.length > 0) {
            rows.push(
              <div key={title} className="mb-2">
                <h3 className="font-semibold text-gray-800">{title}</h3>
                <ul className="ml-4 list-disc text-gray-700">
                  {perms.map((p) => (
                    <li key={p}>{p}</li>
                  ))}
                </ul>
              </div>
            );
          }
        }

        // subModule
        if (item.subModule) {
          loop(item.subModule, title);
        }
      });
    };

    loop(obj);
    return rows;
  };

  if (!open) return null;

  return (
    <div className="bg-black/40 fixed inset-0 z-50 flex items-center justify-center px-4 backdrop-blur-sm">
      <div
        ref={modalRef}
        className="w-full max-w-md rounded-xl bg-white p-6 shadow-xl transition-all"
      >
        <h2 className="mb-3 text-lg font-semibold text-gray-800">
          Role Permissions Details
        </h2>

        <div className="max-h-72 overflow-auto rounded-md bg-gray-100 p-3 text-left text-sm">
          <pre className="whitespace-pre-wrap text-gray-700">
            {/* {JSON.stringify(permission, null, 2)} */}
            {/* {JSON.stringify(getSelectedPermissions(permission), null, 2)} */}
          </pre>
          <div className="space-y-3">
            {renderPermissions(getSelectedPermissions(permission))}
          </div>
        </div>

        <button
          className="mt-4 w-full rounded-lg bg-[#c51369] py-2 text-white transition hover:bg-[#a81058]"
          onClick={onClose}
        >
          Close
        </button>
      </div>
    </div>
  );
};

export default PermissionViewModal;
